import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Combobox, Text, Flex } from '@applyboard/crystal-ui';
import { SearchOutlineIcon } from '@applyboard/ui-icons';
import React from 'react';
import { useStudentDropdownOptions } from "./data";
import { useDebouncedState } from '@applyboard/ui-utils';
import { EligibilityResults } from "../EligibilityResult";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function EligibilityStep(_ref) {
  var _state$context$select;
  var state = _ref.state,
    dispatch = _ref.dispatch,
    disableStudentSelector = _ref.disableStudentSelector,
    onSearchError = _ref.onSearchError,
    onSearchSuccess = _ref.onSearchSuccess;
  var _useDebouncedState = useDebouncedState(''),
    _useDebouncedState2 = _slicedToArray(_useDebouncedState, 3),
    debouncedSearchQuery = _useDebouncedState2[1],
    setSearchQuery = _useDebouncedState2[2];
  var _useStudentDropdownOp = useStudentDropdownOptions({
      searchQuery: debouncedSearchQuery,
      selectedStudent: state.context.selectedStudent,
      onError: onSearchError,
      onSuccess: onSearchSuccess
    }),
    students = _useStudentDropdownOp.students;
  return _jsxs(Flex, {
    gap: 4,
    pt: 4,
    direction: "column",
    children: [_jsx(Text, {
      children: "Please select a student to check their eligibility for this program."
    }), _jsx(Combobox, {
      leadIcon: SearchOutlineIcon,
      label: "Student",
      value: ((_state$context$select = state.context.selectedStudent) === null || _state$context$select === void 0 ? void 0 : _state$context$select.id) || '',
      onChange: function onChange(studentId) {
        var student = students === null || students === void 0 ? void 0 : students.find(function (item) {
          return item.value === studentId;
        });
        if (!student) return;
        dispatch({
          type: 'SELECTED_STUDENT',
          student: {
            name: student.label,
            id: student.value
          }
        });
      },
      disabled: state.value === 'checking_eligibility' || disableStudentSelector,
      onSearch: setSearchQuery,
      invalid: state.value === 'missing_student',
      helpText: state.value === 'missing_student' ? 'Please select a student' : undefined,
      filterOption: function filterOption(option, query) {
        return option.label.toLowerCase().includes(query.trim().toLowerCase());
      },
      children: students.map(function (student) {
        return _jsx(Combobox.Option, {
          label: student.label,
          value: student.value
        }, student.value);
      })
    }), _jsx(EligibilityResults, {
      eligibilityStatus: state.value,
      eligibilityPermissions: state.context.eligibilityPermissions,
      eligibilityDetails: state.context.eligibilityDetails,
      selectedStudent: state.context.selectedStudent
    })]
  });
}